import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
export const DiscussionsCommentV2 = (param)=>{
    let { actions, author, avatar, className, comment, commentMetadata, meta, secondaryActions, timestamp, ...restOfProps } = param;
    return /*#__PURE__*/ _jsxs("article", {
        className: tailwindMerge("group/discussions-comment flex w-full items-start gap-1 px-3 py-4", className),
        "data-testid": "DISCUSSIONS_COMMENT",
        ...restOfProps,
        children: [
            avatar,
            /*#__PURE__*/ _jsxs("div", {
                className: "flex grow flex-col gap-1",
                children: [
                    /*#__PURE__*/ _jsxs("header", {
                        className: "flex items-center justify-between gap-1",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center gap-1",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "max-w-32 truncate text-12 font-semibold text-grey-12",
                                        "data-testid": "DISCUSSIONS_COMMENT_AUTHOR",
                                        children: author
                                    }),
                                    commentMetadata && /*#__PURE__*/ _jsx("div", {
                                        className: "shrink-0 text-12 font-semibold text-grey-12",
                                        children: commentMetadata
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center gap-2",
                                children: [
                                    !!timestamp && /*#__PURE__*/ _jsx("time", {
                                        className: "shrink-0 text-10 text-grey-10",
                                        "data-testid": "DISCUSSIONS_COMMENT_TIMESTAMP",
                                        dateTime: timestamp,
                                        children: timestamp
                                    }),
                                    meta && /*#__PURE__*/ _jsx("div", {
                                        className: "mr-2 shrink-0 text-10 font-bold text-grey-10",
                                        children: meta
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("section", {
                        className: "text-12 font-medium text-grey-11",
                        children: comment
                    }),
                    (secondaryActions || actions) && /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex gap-2 group-hover/discussions-comment:[&_*]:!text-grey-12",
                                children: secondaryActions
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "flex-1"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "shrink-0 gap-1 text-12 text-grey-10 opacity-0 group-hover/discussions-comment:opacity-100 group-hover/discussions-comment:[&_*]:!text-grey-12",
                                children: actions
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
